import { render, staticRenderFns } from "./ModalClientPrint.vue?vue&type=template&id=049cf098&"
import script from "./ModalClientPrint.vue?vue&type=script&lang=js&"
export * from "./ModalClientPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports